import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Tenders from "@/pages/Tenders";
import CreateTender from "@/pages/CreateTender";
import TenderDetail from "@/pages/TenderDetail";
import CountryIntel from "@/pages/CountryIntel";
import CountryProfile from "@/pages/CountryProfile";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import { AuthProvider, useAuth } from "@/lib/AuthContext";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-sm text-slate-400">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/tenders" element={<Tenders />} />
              <Route path="/tenders/new" element={<CreateTender />} />
              <Route path="/tenders/:id" element={<TenderDetail />} />
              <Route path="/countries" element={<CountryIntel />} />
              <Route path="/countries/:name" element={<CountryProfile />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
